/*
 * Resolves after `ms`. The global setTimeout rather than window's: nothing here needs a DOM, and
 * depending on one would keep this — and anything built on it — out of a non-browser test.
 */
async function sleep(ms: number): Promise<void> {
    return new Promise((resolve): void => {
        setTimeout(resolve, ms);
    });
}

// ----------------------------------------------------------------------------

export { sleep };
